var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{ref:"item",staticClass:"js-select2-custom custom-select",staticStyle:{"opacity":"0"},attrs:{"size":"1","data-hs-select2-options":_vm.optionsString},on:{"change":_vm.handleChange}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }